export function ClipboardChecklistIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4768 17.2463C17.0067 17.2463 17.4368 17.6755 17.4368 18.2053C17.4368 18.7352 17.0067 19.1643 16.4768 19.1643H8.44167C7.91181 19.1643 7.48269 18.7352 7.48269 18.2053C7.48269 17.6755 7.91181 17.2463 8.44167 17.2463H16.4768Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M16.4768 13.7786C17.0067 13.7786 17.4368 14.2077 17.4368 14.7375C17.4368 15.2674 17.0067 15.6965 16.4768 15.6965H8.44167C7.91181 15.6965 7.48269 15.2674 7.48269 14.7375C7.48269 14.2077 7.91181 13.7786 8.44167 13.7786H16.4768Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M13.9591 7.71375C14.3356 7.40586 14.8917 7.42725 15.2433 7.7782L15.3087 7.85046C15.5961 8.20191 15.5963 8.70935 15.3097 9.0614L15.2443 9.13464L12.4279 11.9569C12.2479 12.1373 12.003 12.2391 11.7482 12.2391C11.5253 12.2391 11.3106 12.1607 11.1398 12.0204L11.0695 11.9569L9.67496 10.5594C9.30063 10.1845 9.30105 9.57735 9.67593 9.203L9.74918 9.1366C10.1262 8.83011 10.6816 8.85267 11.0324 9.20398L11.7482 9.92078L13.8859 7.77917L13.9591 7.71375Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M14.6807 0.900391L14.7783 0.905273C15.2623 0.954241 15.6396 1.36251 15.6396 1.85938V2.9834H17.4814C19.4321 2.98345 21.0186 4.56987 21.0186 6.52051V15.2773C21.0186 15.8072 20.5894 16.2373 20.0596 16.2373C19.5297 16.2373 19.1006 15.8072 19.1006 15.2773V6.52051C19.1006 5.62805 18.3739 4.90141 17.4814 4.90137H15.6396V5.32422C15.6396 5.85406 15.2105 6.28415 14.6807 6.28418H10.2383C9.70842 6.28418 9.2793 5.85408 9.2793 5.32422V4.90137H7.4375C6.54501 4.90137 5.81836 5.62802 5.81836 6.52051V19.5625C5.81836 20.455 6.54501 21.1816 7.4375 21.1816H17.4814C18.3739 21.1816 19.1006 20.455 19.1006 19.5625C19.1006 19.0326 19.5297 18.6035 20.0596 18.6035C20.5894 18.6036 21.0186 19.0327 21.0186 19.5625C21.0186 21.5131 19.4321 23.0996 17.4814 23.0996H7.4375C5.48683 23.0996 3.90039 21.5132 3.90039 19.5625V6.52051C3.90039 4.56984 5.48683 2.9834 7.4375 2.9834H9.2793V1.85938C9.2793 1.32951 9.70842 0.900391 10.2383 0.900391H14.6807ZM11.1973 4.36523H13.7217V2.81836H11.1973V4.36523Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
    </svg>
  );
}
